<template>
  <div id="guided-creation-inclusions-wrapper">
    <horizontal-item-scroll-window
      id="add-forms-wrapper"
      title="Forms (product standards already selected)"
    >
      <item-tile
        :selected="true"
        :text="form.name"
        v-for="(form, index) in event.forms"
        :key="index"
        @click="toggleItem('forms', form)"
      />
      <item-tile
        :selected="false"
        v-for="(form, index) in forms"
        :key="index"
        :text="form.name"
        @click="toggleItem('forms', form)"
      />
    </horizontal-item-scroll-window>
    <horizontal-item-scroll-window
      id="add-contracts-wrapper"
      title="Contracts (product standards already selected)"
    >
      <item-tile
        :selected="true"
        v-for="(contract, index) in event.contracts"
        :key="index"
        :text="contract.contractName"
        @click="toggleItem('contracts', contract)"
      />
      <item-tile
        :selected="false"
        v-for="(contract, index) in contracts"
        :key="index"
        :text="contract.contractName"
        @click="toggleItem('contracts', contract)"
      />
    </horizontal-item-scroll-window>
  </div>
</template>
<script>
import HorizontalItemScrollWindow from "../../../../Components/UI/HorizontalItemScrollWindow.vue";
import ItemTile from "../../../../Components/UI/ItemTile.vue";

export default {
  data() {
    return {};
  },
  computed: {
    forms() {
      return this.$store.getters.forms.filter((x) => {
        return !this.checkEventForPresence("forms", x);
      });
    },
    standardForms() {
      let products = this.event.invoice_products;
      let forms = Array.from(
        new Set(
          products.reduce((acc, product) => {
            if (product.forms) {
              acc.push(...product.forms);
            }
            return acc;
          }, [])
        )
      );
      return forms.map((eventContract) => {
        return this.forms.find((storeContract) => {
          return storeContract.id === eventContract;
        });
      });
    },
    contracts() {
      return this.$store.getters.contracts.filter((x) => {
        return !this.checkEventForPresence("contracts", x);
      });
    },
    standardContracts() {
      let products = this.event.invoice_products;
      let contracts = Array.from(
        new Set(
          products.reduce((acc, product) => {
            if (product.contracts) {
              acc.push(...product.contracts);
            }
            return acc;
          }, [])
        )
      );
      return contracts.map((eventContract) => {
        return this.contracts.find((storeContract) => {
          return storeContract.id === eventContract;
        });
      });
    },
  },
  methods: {
    checkEventForPresence(array, item) {
      let index = this.event[array].findIndex((x) => {
        return item.id
          ? x.config_id === item.id
          : item.config_id
          ? x.config_id === item.config_id
          : x.name === item.name;
      });
      return index >= 0 ? true : false;
    },
    toggleItem(array, item) {
      this.$emit("toggle-item", array, item);
    },
  },
  created() {
    this.standardContracts.forEach((contract) => {
      this.toggleItem("contracts", contract);
    });
    this.standardForms.forEach((form) => {
      this.toggleItem("forms", form);
    });
  },
  components: {
    HorizontalItemScrollWindow,
    ItemTile,
  },
  props: ["event"],
  emits: ["toggle-item"],
};
</script>
<style scoped>
@media screen {
  #guided-creation-inclusions-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  #add-products-wrapper {
    margin-left: 60px;
  }

  #add-adjustments-wrapper {
    margin-left: 60px;
  }

  h4 {
    text-align: left;
  }
  .horizontal-scroll-container {
    display: flex;
    width: 100%;
    overflow-x: scroll;
  }

  .scroll-padding {
    min-width: 20px;
    height: 100%;
  }
  @media (min-width: 800px) {
    #guided-creation-inclusions-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }
    #add-forms-wrapper {
      margin-left: 60px;
    }

    #add-contracts-wrapper {
      margin-left: 60px;
    }

    h4 {
      text-align: left;
    }
    .horizontal-scroll-container {
      display: flex;
      width: 100%;
      overflow-x: scroll;
    }

    .scroll-padding {
      min-width: 20px;
      height: 100%;
    }
  }
}
</style>
